import { createSlice } from "@reduxjs/toolkit";
import { TRACKCO } from "modules/trackco/constants";
import {
  validateInvitationCode,
  validateResetPasswordToken,
  additionalJoin,
  newJoin,
} from "../action";

const initialState = {
  inviter: {
    distributor: {
      uuid: "",
      picture: "",
      name: "",
      firstName: "",
      lastName: "",
      email: "",
    },
    branch: {
      uuid: "",
      picture: "",
      name: "",
    },
    isInvitationValid: false,
  },
  profile: {
    type: "",
    invitationCode: "",
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    gender: "",
    countryCode: "",
    phoneNumber: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    locale: "",
    picture: "",
  },
  auth: {
    isAuthenticated: false,
    user: null,
    error: null,
    errorType: null,
  },
};

const trackcoSlice = createSlice({
  name: TRACKCO,
  initialState,
  reducers: {
    setInvitationCode(state, action) {
      const { payload } = action;

      state.profile.invitationCode = payload.invitationCode;
    },
    setVerificationEmail(state, action) {
      const { payload } = action;

      state.profile.email = payload.email;
    },
    clearAuthError(state) {
      state.auth.error = null;
      state.auth.errorType = null;
    },
    logout(state) {
      state.auth.isAuthenticated = false;
      state.auth.user = null;
      state.auth.error = null;
      state.auth.errorType = null;
    },
  },
  extraReducers: {
    [validateInvitationCode.fulfilled]: (state, action) => {
      const { payload } = action;

      state.inviter.isInvitationValid = payload.data.is_valid;
      if (payload.data.is_valid) {
        state.inviter.branch.uuid = payload.data.branch.uuid;
        state.inviter.branch.name = payload.data.branch.name;
        state.inviter.branch.picture = payload.data.branch.picture
          ? payload.data.branch.picture.url
          : "";
        if (payload.data.distributor !== null) {
          state.inviter.distributor.uuid = payload.data.distributor.uuid;
          state.inviter.distributor.picture = payload.data.distributor.picture;
          state.inviter.distributor.name = payload.data.distributor.name;
          state.inviter.distributor.firstName =
            payload.data.distributor.first_name;
          state.inviter.distributor.lastName =
            payload.data.distributor.last_name;
          state.inviter.distributor.email = payload.data.distributor.email;
        }
      }
    },

    [validateResetPasswordToken.fulfilled]: (state, action) => {
      const { payload } = action;

      if (payload.data.is_valid) {
        state.profile.email = payload.data.user.email;
        state.profile.picture = payload.data.user.picture;
      }
    },

    [additionalJoin.pending]: (state) => {
      state.auth.error = null;
      state.auth.errorType = null;
    },
    [additionalJoin.fulfilled]: (state, action) => {
      const { payload } = action;

      if (payload.success) {
        state.auth.isAuthenticated = true;
        state.auth.isLoggedIn = true;
        state.auth.loginCompleted = true;
        state.auth.user = payload.data;
        state.auth.error = null;
        state.auth.errorType = null;
      } else {
        state.auth.isAuthenticated = false;
        state.auth.isLoggedIn = false;
        state.auth.loginCompleted = false;
        state.auth.error = payload.message || "Login failed";
        if (payload.code === "error.ERROR_EMAIL_NOT_VERIFIED") {
          state.auth.errorType = "verify_email";
        } else {
          state.auth.errorType = payload.errorType || "unknown_error";
        }
      }
    },
    [additionalJoin.rejected]: (state, action) => {
      state.auth.isAuthenticated = false;
      if (
        action.payload &&
        action.payload.code === "error.ERROR_EMAIL_NOT_VERIFIED"
      ) {
        state.auth.error = action.payload.message || "Login request failed";
        state.auth.errorType = "verify_email";
      } else {
        state.auth.error =
          (action.payload && action.payload.message) ||
          action.error.message ||
          "Login request failed";
        state.auth.errorType = "request_error";
      }
    },

    [newJoin.pending]: (state) => {
      state.auth.error = null;
      state.auth.errorType = null;
    },
    [newJoin.fulfilled]: (state, action) => {
      const { payload } = action;

      if (payload.success) {
        state.auth.error = null;
        state.auth.errorType = null;
      } else {
        state.auth.error = payload.message || "Signup failed";
        state.auth.errorType = payload.errorType || "unknown_error";
      }
    },
    [newJoin.rejected]: (state, action) => {
      state.auth.error = action.error.message || "Signup request failed";
      state.auth.errorType = "request_error";
    },
  },
});

export const {
  setInvitationCode,
  setVerificationEmail,
  clearAuthError,
  logout,
} = trackcoSlice.actions;

export const trackcoReducer = trackcoSlice.reducer;
